import { render, staticRenderFns } from "./BedTagsItem.vue?vue&type=template&id=63e81b38&"
import script from "./BedTagsItem.vue?vue&type=script&lang=js&"
export * from "./BedTagsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports